import { useState } from "react";
import { Service } from "@/types/dashboard";
import { ServiceItem } from "./ServiceItem";

interface ServiceListProps {
  services: Service[];
  userCategories: any[];
  onUpdateServiceCategory: (serviceId: string, categoryId: string, newUserCategories: any[]) => void;
  onEditService: (service: Service) => void;
  onDeleteService: (serviceId: string) => void;
  onPreviewService?: (service: Service) => void;
  onToggleVisibility?: (service: Service) => void;
  isDeleting?: {[key: string]: boolean};
  currency?: string | null;
  serviceImagesMap: {[key: string]: any[]};
  onUserCategoriesUpdate?: (newCategories: any[]) => void;
}

export const ServiceList = ({
  services,
  userCategories,
  onUpdateServiceCategory,
  onEditService,
  onDeleteService,
  onPreviewService,
  onToggleVisibility,
  isDeleting = {},
  currency,
  serviceImagesMap,
  onUserCategoriesUpdate
}: ServiceListProps) => {
  console.log('ServiceList received serviceImagesMap:', serviceImagesMap);
  
  return (
    <div className="divide-y divide-gray-100">
      {services.map(service => {
        const serviceImages = serviceImagesMap[service.id] || [];
        console.log(`Service ${service.id} images:`, serviceImages);
        return (
          <ServiceItem
            key={service.id}
            service={service}
            userCategories={userCategories}
            onUpdateServiceCategory={onUpdateServiceCategory}
            onEditService={onEditService}
            onDeleteService={onDeleteService}
            onPreviewService={onPreviewService}
            onToggleVisibility={onToggleVisibility}
            isDeleting={!!isDeleting[service.id]}
            currency={currency}
            serviceImages={serviceImages}
            onUserCategoriesUpdate={onUserCategoriesUpdate}
          />
        );
      })}
    </div>
  );
};
